import type { DocumentDTO } from "@/modules/performance/domain/contracts";

export type DocumentPrintSignatureOptions = {
  /** Pre-printed studio stamp image — blank area remains when off. */
  includeStudioStamp: boolean;
  /** Pre-printed studio signature image — blank area remains when off. */
  includeStudioSignature: boolean;
};

export function defaultDocumentPrintSignatureOptions(
  _documentType: DocumentDTO["documentType"],
  status: DocumentDTO["status"],
): DocumentPrintSignatureOptions {
  const isIssued = status !== "draft" && status !== "voided";
  return {
    includeStudioStamp: isIssued,
    includeStudioSignature: isIssued,
  };
}

/** Show combined studio stamp/signature asset when both options are enabled. */
export function resolveStudioPrintImage(
  options: DocumentPrintSignatureOptions,
): boolean {
  return options.includeStudioStamp && options.includeStudioSignature;
}
